// src/app/servicios/paginacion/pagination/paginationcard/pagination.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  private currentPage = new BehaviorSubject<number>(0); // Página inicial
  private pageSize = new BehaviorSubject<number>(1); // Configuración dinámica del tamaño de página

  // Observables para suscribirse a los cambios en currentPage y pageSize
  currentPage$: Observable<number> = this.currentPage.asObservable();
  pageSize$: Observable<number> = this.pageSize.asObservable();

  /**
   * Cambia la página actual si el índice es >= 0.
   * @param page Número de la página a establecer
   */
  setPage(page: number): void {
    if (page >= 0) {
      this.currentPage.next(page);
    }
  }

  /**
   * Configura dinámicamente el tamaño de la página (elementos por página).
   * @param size Tamaño de la página a establecer
   */
  setPageSize(size: number): void {
    if (size > 0) {
      this.pageSize.next(size);
    }
  }

  /**
   * Avanza a la siguiente página si no es la última.
   * @param totalItems Total de elementos disponibles
   */
  nextPage(totalItems: number): void {
    const maxPage = this.getMaxPage(totalItems);
    if (this.getCurrentPage() < maxPage) {
      this.currentPage.next(this.getCurrentPage() + 1);
    }
  }

  /**
   * Retrocede a la página anterior si no es la primera.
   */
  previousPage(): void {
    if (this.getCurrentPage() > 0) {
      this.currentPage.next(this.getCurrentPage() - 1);
    }
  }

  /**
   * Obtiene la página máxima en función del total de elementos y el tamaño de la página.
   * @param totalItems Total de elementos disponibles
   * @returns Número de la página máxima
   */
  getMaxPage(totalItems: number): number {
    return Math.ceil(totalItems / this.getPageSize()) - 1;
  }

  /**
   * Obtiene el valor actual de la página.
   * @returns Página actual
   */
  getCurrentPage(): number {
    return this.currentPage.value;
  }

  /**
   * Obtiene el tamaño de la página actual.
   * @returns Tamaño de la página
   */
  getPageSize(): number {
    return this.pageSize.value;
  }
}
